import request from '../utils/request'


export function index(params) {
    return request({
        url: '/express',
        method: 'get',
        params
    })
}

export function inventory(params) {
    return request({
        url: '/express/inventory',
        method: 'get',
        params
    })
}


export function show(id) {
    return request({
        url: `/express/${id}`,
        method: 'get'
    })
}

export function store(data) {
    return request({
        url: '/express',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: `/express/${data.id}`,
        method: 'put',
        data
    })
}

export function destroy(id) {
    return request({
        url: `/express/${id}`,
        method: 'delete',
    })
}